// World 16 (Riven) — second post-launch expansion world. First
// BOARD-GEOMETRY mechanic: levels use distinctive hole patterns that
// reshape the playable region. Engine and solver are unchanged from W1
// — `holes` field has been on LevelDef since v1, every level just had
// `holes: []`. W16 is the first world to actually use it.
//
// Spec: docs/future/w15-w20-plan.md §1 W16, plus
//   tools/w16-hole-templates.mjs for the four geometric patterns
//   (Ring, Corridor, Crescent — Island deferred to v1.0.x because
//   tiles in disconnected islands can never merge, requires
//   island-aware tile placement).
//
// Progression (10 levels, d=3-7 band):
//   L1: d=3 r=4 Corridor — gentlest intro
//   L2-L3: d=4 r=3 — first "wait, what?" moments
//   L4-L5: d=5 r=3 — mid arc
//   L6-L7: d=6 r=3 (and Ring closer for L7)
//   L8-L10: d=7 mix of r=3 and r=4 — peak Riven complexity
//
// The world feels different from W15 — Cairn breaks "empty the board"
// reflex via objective change; Riven breaks it via geometry change.
// Two adjacent worlds, two categorically distinct kinds of unlearning.
//
// Generator: tools/generate-parallel.mjs --world 16 (4 configs across
// Ring r=3, Corridor r=4, Crescent r=3, Crescent r=4). Walltime ~2h
// per the Ring config's high solver-truncation rate. Pool of 183
// candidates curated to 10 via selectByBucket.
import type { LevelDef } from '@tessera/engine';
import { WORLD_16_GENERATED } from './world16-generated';

export const WORLD_16_LEVELS: LevelDef[] = [...WORLD_16_GENERATED];
